<template>
  <HeaderTrade
    :eventLeagueTapType="currentSelectTap"
  /> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">

      <!-- <div class="top-nav-tab">
          <ul @click="onTradeTopNav">
            <li><router-link :to="{ name: 'EventLeague',query: {type: '전체'} }" :class="currentPage == 'EventLeague'?'active':''">이벤트리그</router-link></li>
          </ul>
      </div> -->

      <div class="league-list-status fm-top-tab">
        <div class="fm-tab-list">
          <!-- tab button -->
          <ul class="nav nav-tabs" >
            <li>
              <button class="nav-link" :class="currentSelectTap =='1'?'active':''"  type="button" @click="onClickTap('1')">전체</button>
            </li>
            <li>
              <button class="nav-link" :class="currentSelectTap=='2'?'active':''"  type="button" @click="onClickTap('2')">진행 중</button>
            </li>
            <li>
              <button class="nav-link" :class="currentSelectTap=='3'?'active':''" type="button" @click="onClickTap('3')">참가 중</button>
            </li>
            <li>
              <button class="nav-link" :class="currentSelectTap=='4'?'active':''"  type="button" @click="onClickTap('4')">종료</button>
            </li>
          </ul>
        </div>
      </div>
      
      <div class="league-area">

        <!-- 대회 리스트 -->
        <ul class="league-list">
          <li   v-for="(item, index) in arrSortSpaceList"
                :key = index
          >           
            <router-link :to="{ name:'EventLeagueView', params:{ id:item.ID } }" >
              <div class="league-thum">
                <div class="thum">
                    <img :src="item.THUMBNAIL_IMG_URL" alt="대회썸네일">
                </div>
                <span v-if="item.isMine"
                  class="status par"
                >
                  참가중
                </span>               
                <span v-else
                  class="status"
                  :class="item.STATUS=='1'?'ongoing':''"
                >{{item.STATUS=='1'?'진행중':item.STATUS=='9'?'종료':'대기중'}}</span>     

                <span 
                  v-if="item.ISPRIVATE=='Y'"
                  class="private"                  
                >
                <img src="@/assets/images/trade/ico_lock_red.png/" alt="비공개"></span>
              </div>

              <div class="league-info">
                <div class="box-title">
                  <p class="title text-truncate">{{item.NAME}}</p>
                  <div class="day">
                    <span  v-if="item.STATUS=='1'" class="d-day">{{'D-' + getEndDateDiff(item.ENDDATE)}}</span>
                  </div>
                </div>
                <div class="box-info">
                  <ul class="inner-text">
                    <li>
                        <span class="num">{{getChangeDateStr(item.STARTDATE)}}</span>
                    </li>
                    <li>
                        <span class="num"><strong>{{Constant.UTIL.numberWithCommas(item.REWARD)}} 원</strong></span>
                    </li>
                    <li>
                        <span class="num">{{getTradeType(item.TYPE)}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </router-link>
          </li>
          


        </ul>
      </div>


        <!-- 페이징 start-->
        <!-- <div class="paging-area mb-4">
            <v-pagination                  
                v-model="currentPage"
                :pages='numberOfPages'
                :rangeSize="1"
                @update:modelValue="updateHandler(currentPage, categoryType, categoryCode)"
            />
        </div> -->
        <!-- //페이징 end -->



    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
  <Footer/>
</template>

<script>

import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';
import { computed, ref, onMounted, watch } from 'vue'
import {useRoute }from 'vue-router'
import {useApicall} from '@/composables/commonFn';
import moment from 'moment';
import Constant from '@/constant.js';
export default {
  components:{  
  HeaderTrade, 
  Footer,
},
  setup(){
    const store = useStore();
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_eventLeague'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'EventLeague');    
    const route = useRoute();

    const currentPage = computed(() => store.state.common.currentPage);
    const arrSpaceList = ref([]);
    const arrAttendSpaceList = ref([]);
    const arrSortSpaceList = ref([]);
    const isLogin = computed(() => store.state.user.isLogin); 
    const {apiCall_g, apiCall_gt} = useApicall();

     const routeParamsType = computed(() => route.params.type);

    const currentSelectTap = ref(routeParamsType.value)
    watch(routeParamsType,()=>{
   
      currentSelectTap.value = routeParamsType.value;
      setDisplayList(currentSelectTap.value)
    })



    const getSpacelist = async(status = null)=>{
      var res = null 
      if(status)
      {
          res = await apiCall_g(`index/getspacelist?status=${status}&applyType=C`);
      }
      else
      {
          res = await apiCall_g(`index/getspacelist?applyType=C`);
      }
     
      if( !res.dataList ) res.dataList = [];
      return res.dataList;  
    }  


    const getAttendSpacelist = async()=>{      
      var res = await apiCall_gt(`vspace/getaccountlist?isBeforeEnddate=Y&applyType=C`);
      if( !res.dataList ) res.dataList = [];
      return res.dataList;  
    }  


    const onClickTap = (type)=>{
       currentSelectTap.value = type;     
       setDisplayList(type);    
    }


    const setDisplayList = ( type )=>{
     
        if(type=='1')
       {
           sortSpaceList()
       }
       else  if(type=='2')
       {
          sortSpaceList(1)
       }
       else  if(type=='3')
       {
         sortSpaceList(2)
       }
       else  if(type=='4')
       {
         sortSpaceList(9)
       }
    }

    


    const sortSpaceList = async (status = null) =>{
        arrSortSpaceList.value = [];
        arrSpaceList.value = await getSpacelist(status==2?null:status);
        if(status == 9)
        {
          arrSortSpaceList.value = arrSpaceList.value;
          return;
        }
        if(isLogin.value)
        {
          arrAttendSpaceList.value =  await getAttendSpacelist();   
          // arrAttendSpaceList.value.forEach(_element => {
          //   const found =  arrSpaceList.value.find(element => element.ID == _element.SPACE_ID);
          //     //console.log("found:", _element.ID)
          //   if(found)
          //   {
          //    // console.log("found:", found)
          //     if(found.STATUS == '1')
          //     {
          //         found.isMine = true;
          //         arrSortSpaceList.value.push(found)
          //     }
          //   }
          // });
         arrSpaceList.value.forEach(_element => {
          const found =  arrAttendSpaceList.value.find(element => element.SPACE_ID == _element.ID);
          if(found) 
          {
            if(_element.STATUS == '1') 
            {
              _element.isMine = true;
              arrSortSpaceList.value.push(_element)
            }
          }
         })


        }
        if(status == 2)
        {        
          return;
        }
        var anotherItems = [];
        arrSpaceList.value.forEach(element => {
          if(!element.isMine)
          {          
            anotherItems.push(element);
          }
        })

        var arr_1 =  anotherItems.filter(Symbol => Symbol.STATUS == '1');
        var arr_3 =  anotherItems.filter(Symbol => Symbol.STATUS == '3');
        var arr_9 =  anotherItems.filter(Symbol => Symbol.STATUS == '9');
        var all  = arr_1.concat(arr_3).concat(arr_9);
        arrSortSpaceList.value = arrSortSpaceList.value.concat(all);
    }
    onMounted(()=>{ 

      console.log("onMounted", currentSelectTap.value)
      setDisplayList(currentSelectTap.value)     
     // console.log("arrSpaceList: ",arrSortSpaceList.value, arrAttendSpaceList.value, isLogin.value)

    }) 

    const getEndDateDiff =(endDate)=>{  
        var end = moment(endDate, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
      //  console.log("getEndDateDiff: ", end)
        var now = moment(new Date());
        var duration = moment.duration(now.diff(end));
        //console.log(duration.asDays())
        return Math.floor(Math.abs(duration.asDays()))
     }

    const getTradeType =(type)=>{  
      var result = ""
      if (type == 'S') result="주식거래"
      else if(type == 'F') result="선물거래"
      else if(type == 'C') result="코인거래"
      else if(type == 'G') result="코인선물거래"

      return result;
    }

    const getChangeDateStr =(str)=>{  
       return moment(str, "YYYYMMDDhhmmss").format("YYYY.MM.DD");
    }
    return {      
      arrSortSpaceList,
      getEndDateDiff,
      currentPage,
      onClickTap,
      Constant,
      getTradeType,
      getChangeDateStr,
      currentSelectTap
    }
  }
}
</script>

<style>

</style>